type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/**
 * YouTube-style "share" arrow used on the Shorts surface action rail.
 * A right-pointing arrow with a curved tail sweeping up from below, drawn
 * as a single closed outlined silhouette (filled arrow shape, stroke-only
 * rendering driven by `strokeColor`).
 *
 * Distinct from `LinkedInShareIcon`'s upward hook so the two shorts
 * overlays read as different platforms at a glance.
 */
const YouTubeShareIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
    strokeWidth = '1.6',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      {/*
        Closed silhouette of a right-pointing share arrow:
        - Start at the upper edge of the tail's left end (low-left).
        - Sweep up and right along the tail's top edge to the arrowhead base.
        - Triangle: out to the arrow tip, back to the lower base corner.
        - Sweep back down and left along the tail's bottom edge.
        - Close to the starting point — a single outlined arrow shape.
      */}
      <path
        d="M3.5 16 C 5 12, 9 10, 14 10 L 14 6 L 21 11.5 L 14 17 L 14 13 C 9.5 13, 6.5 14.5, 5 17 Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default YouTubeShareIcon;
